import settings from '../../../config/settings';
import urlJoin from 'url-join';
import _ from 'lodash';

const appBaseUrl = _.get(settings, 'appBaseURL', '/');

export function getAbsoluteAssetUrl(localUrl) {
  return urlJoin(appBaseUrl, localUrl);
}


// WEBPACK FOOTER //
// ./shared/utils/PathUtils.js